import { render, staticRenderFns } from "./DepositsTable.vue?vue&type=template&id=219ba175"
import script from "./DepositsTable.vue?vue&type=script&lang=js"
export * from "./DepositsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports